import { useState } from "react";
import Card from "react-bootstrap/Card";
import { useDispatch } from "react-redux";
import ListGroup from "react-bootstrap/ListGroup";
import { AiOutlineDelete } from "react-icons/ai";
import { Modal, Button } from "react-bootstrap";
import { deleteAnArbo } from "../../redux/actions/supAdmin";
import Loader from "../../Utils/Loader";

function Arborescences({ data, setGetUpdated, pasDelete }) {
  //console.log("data", data);
  //console.log("dossiers parents", data.dossiersParents);

  const [deleteModal, setDeleteModal] = useState(false);
  const [confirmModal, setConfirmModal] = useState(false);
  const [showLoadingModal, setShowLoadingModal] = useState(false);
  const dispatch = useDispatch();

  const closeDeleteModal = () => {
    setDeleteModal(false);
  };

  const handleDeleteArbo = async () => {
    if (pasDelete === "pasDelete") {
      return alert("Vous ne pouvez supprimer des abroscence");
    }
    setShowLoadingModal(true);
    setDeleteModal(false);
    setConfirmModal(false);
    await dispatch(deleteAnArbo(data._id));
    setGetUpdated(true);
    setShowLoadingModal(false);
  };

  return (
    <div>
      <Card className="w-[14rem] sm:w-[18rem] md:w-[20rem] mx-2 my-2">
        <Card.Body>
          <Card.Title className="flex justify-between items-center">
            {data.name || ""}{" "}
            <AiOutlineDelete
              className={`cursor-pointer ${
                pasDelete === "pasDelete" ? "hidden" : ""
              }`}
              onClick={() => setDeleteModal(true)}
            />
          </Card.Title>
          <Card.Text>Liste des dossiers racines :</Card.Text>
        </Card.Body>
        <ListGroup className="list-group-flush">
          {data &&
            data.dossiersParents.length > 0 &&
            data.dossiersParents.map((dossierParent, index) => (
              <ListGroup.Item key={index}>
                {dossierParent.charAt(0).toUpperCase() + dossierParent.slice(1)}
              </ListGroup.Item>
            ))}
        </ListGroup>
      </Card>
      <Modal show={deleteModal} onHide={closeDeleteModal}>
        <Modal.Header>
          <Modal.Title className="text-sm">
            Supprimer l'arborescence {data.name || ""}
          </Modal.Title>
          <button
            type="button"
            className="text-gray-500 hover:text-gray-700"
            onClick={closeDeleteModal}
          >
            <span className="sr-only">Fermer</span>
            <svg
              className="w-6 h-6 fill-current"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M18.7 5.3c.4.4.4 1 0 1.4L13.4 12l5.3 5.3c.4.4.4 1 0 1.4-.4.4-1 .4-1.4 0L12 13.4l-5.3 5.3c-.4.4-1 .4-1.4 0-.4-.4-.4-1 0-1.4L10.6 12 5.3 6.7c-.4-.4-.4-1 0-1.4.4-.4 1-.4 1.4 0L12 10.6l5.3-5.3c.4-.4 1-.4 1.4 0z"
              />
            </svg>
          </button>
        </Modal.Header>
        <Modal.Body>
          <h1 className="text-center">
            {" "}
            Voulez-vous supprimer cette arborescence ?
          </h1>
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="bg-gray-500 mr-2 hover:bg-gray-700"
            onClick={closeDeleteModal}
          >
            Annuler
          </Button>
          <Button className="bg-blue-500" onClick={() => setConfirmModal(true)}>
            Supprimer
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={confirmModal}
        dialogClassName="max-w-[700px] top-1/4"
        className=" px-2 bg-transparent "
        onHide={() => setConfirmModal(false)}
      >
        <Modal.Header>
          <Modal.Title className="text-sm">
            Confirmation suppression arborescence {data.name || ""}
          </Modal.Title>
          <button
            type="button"
            className="text-gray-500 hover:text-gray-700"
            onClick={closeDeleteModal}
          >
            <span className="sr-only">Fermer</span>
            <svg
              className="w-6 h-6 fill-current"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M18.7 5.3c.4.4.4 1 0 1.4L13.4 12l5.3 5.3c.4.4.4 1 0 1.4-.4.4-1 .4-1.4 0L12 13.4l-5.3 5.3c-.4.4-1 .4-1.4 0-.4-.4-.4-1 0-1.4L10.6 12 5.3 6.7c-.4-.4-.4-1 0-1.4.4-.4 1-.4 1.4 0L12 10.6l5.3-5.3c.4-.4 1-.4 1.4 0z"
              />
            </svg>
          </button>
        </Modal.Header>
        <Modal.Body>
          <h1 className="text-center">
            {" "}
            Etes-vous vouloir supprimer cette arborescence ?
          </h1>
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="bg-gray-500 mr-2 hover:bg-gray-700"
            onClick={closeDeleteModal}
          >
            Annuler
          </Button>
          <Button className="bg-blue-500" onClick={handleDeleteArbo}>
            Confirmer
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal show={showLoadingModal}>
        <Loader />
      </Modal>
    </div>
  );
}

export default Arborescences;
